import { render, staticRenderFns } from "./printSetting.vue?vue&type=template&id=494ce41e&"
import script from "./printSetting.vue?vue&type=script&lang=js&"
export * from "./printSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports